import './AssignmentList.scss'

import React, {Component} from 'react'
import { connect } from 'react-redux'
import AssignmentTable from './AssignmentTable'
import { selectIsTransitionBroker } from 'broker/selectors/auth'
import ReferralNoteModal from '../ReferralNoteModal'

import {
  fetchMarkets, fetchAgents, fetchSourceTypes
} from 'broker/redux/account'

import {
  fetchReleasedAssignments,
  searchReleasedAssignments,
} from 'broker/redux/assignment'
import { BUYER_TYPE, PRICE, REFERRAL_EXPORT_TIMEFRAME, LEAD_TYPE_OPTIONS } from 'common/constants'

import {
  getTimeframeFromFilterList,
  getQueriesFromFilterList,
  exportSearchFiltersForSegment,
  filtersWithValues
} from 'broker/util/helper'

import { segmentEventTracker } from 'common/analytics'
import {GenericLeadsDownloader} from "broker/util/downloader";
import DownloadModal from "broker/views/components/common/DownloadModal";
import {FilteredList} from "broker/views/components/common/Filter/FilteredList";
import _ from "lodash";

const FILTER_KEYS = ['market', 'client', 'price', 'agent', 'source', 'timeframe', 'lead_type']
const FILTER_TYPE_OPTIONS = [
  {value: 'market', label: 'Market'},
  {value: 'client', label: 'Client Category'},
  {value: 'price', label: 'Price Range'},
  {value: 'agent', label: 'Agent Name'},
  {value: 'source', label: 'Source Name'},
  {value: 'timeframe', label: 'Time Period'},
  {value: 'market_vip', label: 'Market VIP'},
  {value: 'lead_type', label: 'Lead Type'},
]

const MARKET_VIP_FILTER = [{value: 'true', label: 'Only'}]

class ReleasedAssignmentList extends Component  {

  constructor(props) {
    super(props)

    this.state = {
      filters: [{filter_type: 'timeframe', filter_value: 'month'}],
      activeFilters: [{filter_type: 'timeframe', filter_value: 'month'}],
      unusedFilters: FILTER_KEYS.filter(filter => filter.value !== 'timeframe'),
      dirty: false,
      options: {
        client: BUYER_TYPE,
        price: PRICE,
        timeframe: REFERRAL_EXPORT_TIMEFRAME,
        market_vip: MARKET_VIP_FILTER,
        lead_type: LEAD_TYPE_OPTIONS,
        agent: [{value: "waiting-for-agents", label:"Waiting for agents..."}],
      }
    }

    this.downloader = new GenericLeadsDownloader()
    this.handleReleasedAssignmentsExport = this.handleReleasedAssignmentsExport.bind(this)
    this.search = this.search.bind(this)
    this.handleFilter = this.handleFilter.bind(this)
    this.handleSearch = this.handleSearch.bind(this)

  }

  componentWillMount() {
    if (this.props.isTransitionBroker && !_.includes(FILTER_KEYS, 'market_vip')) {
      FILTER_KEYS.push('market_vip')
    }

    this.props.dispatch(fetchMarkets())
      .then(response => {
        const { options } = this.state
        this.setState({
          options: {
            ...options,
            market: response.markets.map(market => {
              return {value: market.id, label: market.name}
            })
          }
        })
      })

    this.props.dispatch(fetchAgents())
      .then(response => {
        const { options } = this.state
        let agentOptions = response.agents.map(agent => {
          return {value: agent.id, label: agent.name}
        })
        if (this.props.account.is_partner_brokerage) {
          agentOptions.unshift({value:'network',label:'Network'})
        }

        this.setState({
          options: {
            ...options,
            agent: agentOptions
          },
          extraForSegment: {
            ...this.state.extraForSegment,
            agentUserHash: response.agents.map(agent => {
              return { id: agent.id, userHash: agent.user_hash }
            })}
        })
      })

    this.props.dispatch(fetchSourceTypes())
      .then(response => {
          const { options } = this.state
          this.setState({
            options: {
              ...options,
              source: response.source_types.map(source_type => {
                return {value: source_type.id, label: source_type.name}
              })
            }
          })
        }
      )
  }

  addFilter = () => {
    this.setState({
      filters: [...this.state.filters].concat({filter_type: null, filter_value: null})
    })
    this.updateFilterType(this.state.filters.length, this.state.unusedFilters[0])
  }

  removeFilter = (idx) => {
    let filters = [...this.state.filters]

    filters.splice(idx, 1)
    let newActiveFilters = filters.filter(filter => filter.filter_type && filter.filter_value)
    let unusedFilters = FILTER_KEYS.filter(val => filters.every(filter => filter.filter_type!==val))

    this.setState({
      filters,
      unusedFilters,
      activeFilters: newActiveFilters,
      dirty: true
    }, this.handleFilter)
  }

  updateFilterType = (idx, filter_type) => {
    let filters = [...this.state.filters]
    filters[idx] = {
      filter_type,
      filter_value: null
    }
    let unusedFilters = FILTER_KEYS.filter(val => filters.every(filter => filter.filter_type!==val))
    this.setState({
      filters,
      unusedFilters
    })
  }

  updateFilterValue = (idx, filter_value, run_search = false) => {
    const search_callback = run_search ? this.handleFilter : null
    let filters = [...this.state.filters]
    filters[idx]['filter_value'] = filter_value
    let activeFilters = filters.filter(filter => filter.filter_type && filter.filter_value)
    this.setState({
      filters,
      activeFilters,
      dirty: true
    }, search_callback)
  }

  handleFilter = _.debounce(() => { this.search() } , 2000)

  handleSearch = _.debounce((searchTerm) => {
    this.setState({searchTerm})
    this.search(searchTerm)
  }, 800)

  search = (term) => {
    this.downloader.initializeSearchState()
    const activeFilters = getQueriesFromFilterList(this.state.activeFilters)
    if (term || !!this.state.searchTerm || activeFilters.length > 0) {
      term = term || this.state.searchTerm
      this.props.dispatch(searchReleasedAssignments(getTimeframeFromFilterList(this.state.activeFilters), term, activeFilters, this.props.nav, true))
        .then(() => {
          this.setState({searching: false})
        }).catch((error) => {
          this.downloader.searchTimedOut()
          throw error
        })
    } else {
      this.props.dispatch(fetchReleasedAssignments(getTimeframeFromFilterList(this.state.activeFilters), this.props.nav, true))
        .then(() =>{
          this.setState({searching: false})
        }).catch(
          (error) => {
            this.downloader.searchTimedOut()
            throw error
          }
        )
    }
    const filteredFilters = filtersWithValues(this.state.filters)
    this.setState({searching: true, dirty: false, filters: filteredFilters})
  }

  handleReleasedAssignmentsExport = () => {
    const baseSegmentProperties = {
      'downloaded_data': 'released_referrals'
    }

    const { activeFilters, extraForSegment } = this.state
    const agentFilter = activeFilters.find(filterEntry => filterEntry.filter_type === 'agent')
    const agentUserHashArray = extraForSegment ? extraForSegment.agentUserHash : []
    const foundAgent = agentFilter && agentUserHashArray.find(agent => agent.id === agentFilter.filter_value)
    const agentUserHash = agentFilter && foundAgent && foundAgent.userHash

    const searchFiltersForSegmentExport = exportSearchFiltersForSegment(
      FILTER_TYPE_OPTIONS,
      this.state.activeFilters,
      agentUserHash && { 'agent': agentUserHash }
    )

    segmentEventTracker('Data Downloaded',{
      ...baseSegmentProperties,
      ...searchFiltersForSegmentExport,
    })
    this.downloader.download({
      exportUrl: '/download/released_assignments',
      auth: this.props.auth, email: this.props.email, dispatch: this.props.dispatch, account: this.props.account,
      activeFilters: this.state.activeFilters, searchTerm: this.state.searchTerm
    })
  }

  render() {

    const { props, state } = this
    const { root } = props
    const { isLoading } = root
    const activeFilters = state.activeFilters

    const defaultNav = {next_page: null, prev_page: null, page_number: 1}
    const useNav = {...defaultNav, ...(_.get(props, 'assignment.nav', {}))}
    const timeFrameFilter = this.state.filters[0]
    const timeFrameOptions = this.state.options[timeFrameFilter.filter_type]

    function getPage(forward) {
      const { activeFilters, searchTerm } = state
      let newNav = {
        'page_number': forward ? useNav.page_number + 1: useNav.page_number - 1,
        'page_key': forward ? useNav.next_page : useNav.prev_page
      }
      props.dispatch(searchReleasedAssignments(getTimeframeFromFilterList(activeFilters), searchTerm, activeFilters, newNav, true))
    }

    function forward() {
      getPage(true)
    }

    function backward() {
      getPage(false)
    }

    function renderSection(assignments) {

      return (
        <div key={"assignmentsList"}>
          { assignments ?
            <AssignmentTable
              activeFilters={activeFilters}
              filterTypeOptions={FILTER_TYPE_OPTIONS}
              showingReleased={true}
              showNote={true}
              assignmentList={assignments}
              fetch={fetchReleasedAssignments} {...props}
            /> : null }
        </div>)
    }

    const NoAssignmentSection = <div className="AssignmentList__none-found">
      <i className="fa fa-flag" aria-hidden="true"/><div>No referrals have been released by your agents.</div>
    </div>

    return (
      <div>
        <div className="AssignmentList">
          <FilteredList
            checkboxOptions={{noOptions: {}}}
            dirty={this.state.dirty}
            filters={this.state.filters}
            filterOptions={this.state.options}
            isLoading={isLoading}
            maxLengthReached={Object.keys(this.state.options).length == (Object.keys(this.state.filters).length)}
            nav={this.props.assignment ? this.props.assignment.nav: null}
            timeFrameFilter={timeFrameFilter}
            timeFrameOptions={timeFrameOptions}
            typeOptionsConsts={FILTER_TYPE_OPTIONS}
            unusedFilters={this.state.unusedFilters}
            onAddFilter={this.addFilter}
            onApply={this.handleFilter}
            onExport={this.handleReleasedAssignmentsExport}
            onPageForward={forward}
            onPageBackward={backward}
            onRemoveFilter={this.removeFilter}
            onSearch={this.handleSearch}
            onUpdateFilterType={this.updateFilterType}
            onUpdateFilterValue={this.updateFilterValue}
          >
            { props.assignment.search_results ? props.assignment.search_results.length !== 0 ? renderSection(props.assignment.search_results) : NoAssignmentSection : <div className="AssignmentList__loading pulse"/> }
          </FilteredList>
        </div>
        <ReferralNoteModal {...props} />
        <DownloadModal {...this.props}/>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  isTransitionBroker: selectIsTransitionBroker(state)
})

export default connect(mapStateToProps)(ReleasedAssignmentList)
